import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { ICommodity } from '../commodity/commodity';
import { IOptionType } from '@zz2/zz2-ui';
import { ICommodityConditionRel } from './commodityConditionRel';
import { ICommodityConditionRelFormValues } from './commodityConditionRelFormValues';
import { ICommodityConditionRelUpsert } from './commodityConditionRelUpsert';
import { ICommodityCondition } from '../commodityCondition/commodityCondition';
import OptionType from '../../optionType';

export default class CommodityConditionRelModelHelper {
    public static createFormValues = (
        commodityConditionRel : ICommodityConditionRel | null,
        commodities : Array<ICommodity>,
        commodityConditions : Array<ICommodityCondition>,
    ) : ICommodityConditionRelFormValues => {
        if (!commodityConditionRel) return {
            id: 0,
            guid: uuidV4(),
            commodity: null,
            condition: null,
            order: 0,
            isSpacer: false,
            isActive: true,
        };

        const commodity = commodities.find(x => x.id === commodityConditionRel.commodityId);
        const condition = commodityConditions.find(x => x.id === commodityConditionRel.conditionId);

        const conditionOption : IOptionType | null = commodityConditionRel.isSpacer
            ? {
                label: `(${commodityConditionRel.order}) <spacer>`,
                value: (-1 * commodityConditionRel.order),
            }
            : (condition)
                ? {
                    label: `(${commodityConditionRel.order}) ${commodityConditions.find(x => x.id === commodityConditionRel.conditionId)?.condition}`,
                    value: commodityConditionRel.conditionId ?? 0,
                }
                :
                null;

        return {
            id: commodityConditionRel.id,
            guid: commodityConditionRel.guid,
            commodity: commodity
                ? OptionType.fromDataModel(commodity)
                : null,
            condition: conditionOption,
            order: commodityConditionRel.order,
            isSpacer: commodityConditionRel.isSpacer,
            isActive: commodityConditionRel.isActive,
        };
    };

    public static createNewFormValue = (
        order : number,
        selectedCommodity : ICommodity | null,
        conditionOption : IOptionType | null,
        isSpacer : boolean,
    ) : ICommodityConditionRelFormValues => {
        return {
            id: 0,
            guid: uuidV4(),
            isActive: true,
        
            order,
            commodity: selectedCommodity
                ? OptionType.fromDataModel(selectedCommodity)
                : null,
            isSpacer,
            condition: conditionOption,
        };
    };

    public static createUpsert = (formValues : ICommodityConditionRelFormValues) : ICommodityConditionRelUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            commodityId: Number(formValues.commodity?.value ?? 0),
            commodityConditionId: !formValues.isSpacer
                ? formValues.condition
                    ? Number(formValues.condition.value)
                    : null
                : null,
            isSpacer: formValues.isSpacer,
            order: formValues.order,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<ICommodityConditionRelFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        commodity: Yup.mixed<IOptionType>().defined().required('Required'),
        condition: Yup.mixed<IOptionType>().defined().nullable(),
        order: Yup.number().typeError('Please enter a number.').required('Required'),
        isSpacer: Yup.boolean().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
